import React, { useEffect } from 'react'
import SiteFooter from '../components/SiteFooter'
import PageHeader from '../components/PageHeader'
import SiteMark from '../components/SiteMark'
import EventList from '../components/EventList'
import {
  broadcast, cleveland, festivalScreenings, otherScreenings,
  onlineScreenings, headers, awardsParagraph, hosting,
} from '../data/record'

const Screenings = () => {
  useEffect(() => {
    document.title = 'Screenings | The Girl and Her Piano'
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className='App page-standard'>
      <SiteMark />
      <PageHeader
        {...headers.screenings}
        title='Screenings'
        srTitle='Screenings and awards, from Bhutan to the Arctic'
        subtitle='Twenty-one awards across eighteen festivals'
      />

      <section className='broadcast-block' data-tone='dark'>
        <div className='content-container'>
          <h2 className='broadcast-heading'>{broadcast.heading}</h2>
          <div className='broadcast-columns'>
            {broadcast.columns.map((col) => (
              <div className='broadcast-col' key={col.label}>
                <p className='broadcast-label'>{col.label}</p>
                <p className='broadcast-text'>{col.text}</p>
              </div>
            ))}
          </div>
          <p className='broadcast-link'>
            <a className='link-button link-button--light' href={broadcast.link.href}
               target='_blank' rel='noopener noreferrer'>{broadcast.link.label}</a>
          </p>
        </div>
      </section>

      <EventList events={[cleveland, ...festivalScreenings, ...otherScreenings]} />

      <section className='online-block' data-tone='light'>
        <div className='content-container'>
          <h2>Online</h2>
          <ul className='online-list'>
            {onlineScreenings.map((item) => (
              <li key={item.title}>
                <span className='online-title'>
                  {item.url
                    ? <a href={item.url} target='_blank' rel='noopener noreferrer'>{item.title}</a>
                    : item.title}
                </span>
                {item.note && <span className='online-note'>{item.note}</span>}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className='awards-block' data-tone='dark'>
        <div className='content-container'>
          <h2 className='awards-heading'>Awards in full</h2>
          <p className='awards-paragraph'>
            {awardsParagraph.map((line, i) => (
              <React.Fragment key={line}>
                {i > 0 && <span className='awards-sep'>|</span>}
                {line}
              </React.Fragment>
            ))}
          </p>
        </div>
      </section>

      <section className='hosting-block' data-tone='light'>
        <div className='content-container'>
          <h2>{hosting.heading}</h2>
          {hosting.body.map((line) => <p className='hosting-text' key={line}>{line}</p>)}
          <p className='hosting-email'>
            <a href={`mailto:${hosting.email}`}>{hosting.email}</a>
          </p>
        </div>
      </section>

      <SiteFooter />
    </div>
  )
}

export default Screenings
